export default __webpack_public_path__ + "static/media/85.2a5ce3d8.gif";